<template>
  <v-app>
    <v-navigation-drawer temporary v-model="drawer" enable-resize-watcher fixed app>
      <v-list>
        <v-list-tile value="true" v-for="(item, i) in items" :key="i" :to="{path: item.url}">
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :scroll-threshold="scrollTreshhold" scroll-off-screen app flat>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="dialog = true">
        <v-icon>help</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <transition name="fade">
        <router-view />
      </transition>
      <v-dialog v-model="dialog" scrollable max-width="800px">
        <v-card>
          <v-card-title>
            <h3>Cómo interpretar los gráficos</h3>
            <v-spacer></v-spacer>
            <v-btn small icon @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="mb-4">
              <h4>Gráfico N° 1: Generación de los Paneles y Consumos de la Red Mensuales</h4>
              <ul>
                <li>Las barras amarillas, representan la generación mensual de los paneles solares.</li>
                <li>La línea continua celeste
                  <span style="background:#fff;border-radius:3px" class="legendConsumoSinPaneles" dir="ltr">
                    <svg version="1.1" class="highcharts-root" style="font-family:&quot;Lucida Grande&quot;, &quot;Lucida Sans Unicode&quot;, Arial, Helvetica, sans-serif;font-size:12px;" xmlns="http://www.w3.org/2000/svg" width="60" height="30" viewBox="0 0 60 30">
                      <path fill="#ffffff" d="M 10 25 L 50 25" stroke="#289cda" stroke-width="2" stroke-dasharray="none"></path>
                    </svg>
                  </span> representa el consumo mensual de la red SIN paneles solares.</li>
                <li>La línea discontinua violeta
                  <span style="background:#fff;border-radius:3px" class="legendConsumoConPaneles" dir="ltr">
                    <svg version="1.1" class="highcharts-root" style="font-family:&quot;Lucida Grande&quot;, &quot;Lucida Sans Unicode&quot;, Arial, Helvetica, sans-serif;font-size:12px;" xmlns="http://www.w3.org/2000/svg" width="60" height="30" viewBox="0 0 60 30">
                      <path fill="#ffffff" d="M 10 25 L 50 25" stroke="#862d86" stroke-width="2" stroke-dasharray="8,6,2,6"></path>
                    </svg>
                  </span>, representa el consumo mensual de la red CON los paneles solares instalados.</li>
              </ul>
            </div>
            <div>
              <h4>Gráfico N° 2: Variación en la Facturación por Ahorro en el Consumo</h4>
              <ul>
                <li>
                  <strong>El gráfico representa únicamente el pago del Cargo Variable [$/kWh] por el consumo, no contempla ningún otro cargo (Cargo fijos, Impuestos, etc.)</strong>
                </li>
                <li>La línea continua roja
                  <span style="background:#fff;border-radius:3px" class="legendSaldoSinPaneles" dir="ltr">
                    <svg version="1.1" class="highcharts-root" style="font-family:&quot;Lucida Grande&quot;, &quot;Lucida Sans Unicode&quot;, Arial, Helvetica, sans-serif;font-size:12px;" xmlns="http://www.w3.org/2000/svg" width="60" height="30" viewBox="0 0 60 30">
                      <path fill="#ffffff" d="M 10 25 L 50 25" stroke="#e74c3c" stroke-width="2" stroke-dasharray="none"></path>
                    </svg>
                  </span>, representa la facturación mensual SIN la instalación de los paneles solares.</li>
                <li>La línea discontinua azul oscuro
                  <span style="background:#fff;border-radius:3px" class="legendSaldoConPaneles" dir="ltr">
                    <svg version="1.1" class="highcharts-root" style="font-family:&quot;Lucida Grande&quot;, &quot;Lucida Sans Unicode&quot;, Arial, Helvetica, sans-serif;font-size:12px;" xmlns="http://www.w3.org/2000/svg" width="60" height="30" viewBox="0 0 60 30">
                      <path fill="#ffffff" d="M 10 25 L 50 25" stroke="#007777" stroke-width="2" stroke-dasharray="8,6,2,6"></path>
                    </svg>
                  </span>, representa la nueva facturación mensual CON la instalación de los paneles solares.</li>
                <li>Todos los valores que se encuentren por encima del “$ 0” son valores estimados en pesos a pagar.</li>
              </ul>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-content>
    <v-footer style="height: auto;background: #fff; padding-bottom: 32px;">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm4 text-xs-center text-sm-left class="no-print">
            <img style="max-height: 120px;" alt="Secretaría de Energía" :src="''+require('@/assets/img/secretaria-de-energia.png')">
          </v-flex>
          <v-flex xs12 sm8 text-xs-center text-sm-right class="no-print" style="padding-top:30px">
            <img style="max-height: 40px;" alt="Subsecretaría de Energías Renovables" :src="''+require('@/assets/img/logo-energias-renovables.png')">
          </v-flex>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm2 text-xs-center text-sm-left class="no-print">
              <p>Version 3.3</p>
            </v-flex>
            <v-flex xs12 sm10 text-xs-center text-sm-left>
              <small>
                Todos los derechos reservados 2018. República Argentina. Ministerio de Hacienda. Secretaría de Energía. Subsecretaría de Coordinación Administrativa. Dirección General de Informática. Hipólito Yrigoyen 250; Código Postal: C1086AAB, CABA; República Argentina.
              </small>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'CalculadorSolar',
  data () {
    return {
      scrollTreshhold: 1,
      dialog: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'home',
          title: 'Home',
          url: '/'
        },
        {
          icon: 'format_list_numbered',
          title: 'Calculador',
          url: '/calculador'
        }
      ],
      title: 'Calculador Solar'
    }
  }
}
</script>

<style>
@-ms-viewport {
  width: device-width;
}
html {
  overflow-y: auto;
  /* overflow-x: hidden; */
}
body {
  overflow: hidden !important;
  width: 100%;
  height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.3s;
}

.fade-enter-active {
  transition-delay: 0.3s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.v-navigation-drawer .v-list a .v-list__tile__title {
  color: black;
  font-weight: 400;
}
.v-navigation-drawer .v-list a.v-list__tile--active {
  background: rgba(0, 0, 0, 0.04);
}

.v-navigation-drawer .v-list a.v-list__tile--active .v-list__tile__title {
  font-weight: 500;
}
.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
  border: 0;
}
</style>
